<!--
	UserAvatar.svelte
-->

<script>
    import { getUserInitials } from '../../common/utils.js';
    import { isShowingUserProfile } from '../../stores/ScreenSettingsStore.js';

    // TCARE components
    import UserProfile from './UserProfile.svelte';

    // SMUI components
    
    export let user;                    // passed in from Header - not from userStore

    const onAvatarClick = (e) => {
        // console.log(user);
		e.stopPropagation();
		e.preventDefault();
        $isShowingUserProfile = !$isShowingUserProfile;
    }

</script>

<style>
    .user-avatar-wrapper {
        height: 36px;
        width: 36px;
        margin-left: 20px;
        /* border: 1px solid green; */
        user-select: none;
    }

    /* empty circle until user initials */
    .user-avatar {
        height: 100%;
        width: 100%;
        font-size: 1em;
        font-weight: normal;
        /* font-family: Arial, Helvetica, sans-serif; */
        /* text-shadow: 1px 1px 1px black; */
        color: var(--tcare-primary);
        background-color: var(--tcare-white);
        border-radius: 50%;
        user-select: none;
    }

    .user-avatar:hover {
        color: var(--tcare-white);
        background-color: var(--tcare-secondary);
    }

    @media screen and (max-width: 600px) {
        .user-avatar {
            height: 30px;
            width: 30px;
            margin-right: 3px;
            font-size: 1em;
        }
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- wrapper is always visible -->
<div class="user-avatar-wrapper flex-center">
    {#if user.isLoggedIn}
        <div class="user-avatar flex-center" on:click={onAvatarClick}>
            {getUserInitials(user.name)}
        </div>
        {#if $isShowingUserProfile}
            <UserProfile {user} />
        {/if}
    {/if}
</div>
